import React from 'react';
import {
  Button,
  VStack,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  HStack,
  Checkbox,
  Box
} from '@chakra-ui/react';
import { AddIcon, CloseIcon } from '@chakra-ui/icons';
import '../../Styles/theme/PasswordModel.css';
import MailImage from '../../Images/Icons/mail.png';

const SendEmailModal = ({
  visible,
  emails,
  emailError,
  onEmailChange,
  onAddEmail,
  onRemoveEmail,
  onShowFrequentEmails,
  onCancel,
  onSend
}) => {
  if (!visible) return null;

  return (
    <div className="model-overlay">
      <div
        className="model"
        style={{
          width: '500px',
          maxWidth: '90vw',
          maxHeight: '90vh',
          overflowY: 'auto',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
          <img src={MailImage} alt="Mail" style={{ width: '50px', height: '50px', marginRight: '10px' }} />
          <div style={{ fontWeight: 'bold', fontSize: '20px' }}>寄送證書</div>
        </div>

        {emails.map((item, index) => (
          <VStack key={index} spacing={3} align="stretch" mb={4} p={3} borderWidth="1px" borderRadius="md">
            <FormControl isRequired isInvalid={emailError && !item.email}>
              <FormLabel>收件人郵箱</FormLabel>
              <Input
                value={item.email}
                onChange={(e) => onEmailChange(index, 'email', e.target.value)}
                placeholder="請輸入收件人郵箱"
              />
              {emailError && !item.email && <FormErrorMessage>{emailError}</FormErrorMessage>}
            </FormControl>

            <FormControl isRequired>
              <FormLabel>收件人姓名</FormLabel>
              <Input
                value={item.name}
                onChange={(e) => onEmailChange(index, 'name', e.target.value)}
                placeholder="請輸入收件人姓名"
              />
            </FormControl>

            <FormControl isRequired>
              <FormLabel>收件人公司</FormLabel>
              <Input
                value={item.company}
                onChange={(e) => onEmailChange(index, 'company', e.target.value)}
                placeholder="請輸入收件人公司名稱"
              />
            </FormControl>

            <FormControl isRequired>
              <FormLabel>運作人管編</FormLabel>
              <Input
                value={item.recipient_company_no || ''}
                onChange={(e) => onEmailChange(index, 'recipient_company_no', e.target.value)}
                placeholder="請輸入運作人管制編號"
              />
            </FormControl>

            <FormControl isRequired>
              <FormLabel>運作場所管編</FormLabel>
              <Input
                value={item.recipient_place_no || ''}
                onChange={(e) => onEmailChange(index, 'recipient_place_no', e.target.value)}
                placeholder="請輸入運作場所管制編號"
              />
            </FormControl>

            <FormControl>
              <Checkbox
                isChecked={item.includePassword}
                onChange={(e) => onEmailChange(index, 'includePassword', e.target.checked)}
              >
                在郵件中包含密碼
              </Checkbox>
            </FormControl>

            <HStack justify="flex-end">
              {emails.length > 1 && (
                <Button
                  size="sm"
                  colorScheme="red"
                  variant="outline"
                  leftIcon={<CloseIcon />}
                  onClick={() => onRemoveEmail(index)}
                >
                  移除此收件人
                </Button>
              )}
            </HStack>
          </VStack>
        ))}

        <Button
          mt={2}
          leftIcon={<AddIcon />}
          colorScheme="blue"
          variant="outline"
          onClick={onAddEmail}
        >
          添加更多收件人
        </Button>

        <Box mt={4}>
          {emailError && (
            <div style={{ color: '#D21C1B', marginTop: '15px', textAlign: 'center', fontWeight: 400, fontSize: '14px' }}>
              {emailError}
            </div>
          )}
          <div className="button-group">
            <button
              type="button"
              onClick={onShowFrequentEmails}
              style={{
                padding: '5px 10px',
                margin: '5px',
                background: 'white',
                color: '#008E96',
                border: '1px solid #008E96',
                fontSize: '14px',
              }}
            >
              常用信箱
            </button>
            <button
              type="button"
              onClick={onCancel}
              style={{
                padding: '5px 10px',
                margin: '5px',
                background: 'white',
                color: '#D21C1B',
                border: '1px solid #D21C1B',
                fontSize: '14px',
              }}
            >
              取消
            </button>
            <button
              type="button"
              onClick={onSend}
              style={{
                padding: '5px 10px',
                margin: '5px',
                background: '#008E96',
                color: 'white',
                border: '1px solid #008E96',
                fontSize: '14px',
              }}
            >
              寄送
            </button>
          </div>
        </Box>
      </div>
    </div>
  );
};

export default SendEmailModal;
